import(/* webpackMode: "eager", webpackExports: ["Body"] */ "/vercel/path0/src/components/Body.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/providers/ClientProvider.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/providers/ProProvider.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/providers/Providers.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/providers/RoleProvider.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css");
